module.exports = __webpack_public_path__ + "ic-edit-lined-blue.svg?e1682dfc74ede6054879e7877d191e8b";